module.exports = __webpack_public_path__ + "static/media/lfv_logo.c3134180.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lfv_logo.png
// module id = 2241
// module chunks = 0